import { useContext } from 'react';

import i18n from '@nextroll/ar-i18n';
// @ts-ignore - no types for ar-style-base
import { InputGroup } from '@nextroll/ar-style-base';

import {
    setFieldFactory,
    setShowFieldErrorFactory,
} from '../../../actions/sign-up/SignUpActions';
import SignUpContext from '../../../contexts/sign-up/SignUpContext';
import usePrefillFromSearchParams from '../../../hooks/sign-up/usePrefillFromSearchParams';
import { required } from '../../../utils/sign-up/fields';
import { isURLValid } from '../../../utils/validators';

export const validate = required((value: string) => {
    if (!isURLValid(value)) {
        return i18n.gettext('Please enter your company URL.');
    }
    return null;
});

const Url = () => {
    const { state, dispatch } = useContext(SignUpContext);

    usePrefillFromSearchParams('url', 'url', validate);

    const field = state.get('fields').url;
    const setField = setFieldFactory(dispatch, 'url');
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value.trim();
        const err = validate(value);
        setField(value, err === null, err);
    };
    const setShowFieldError = setShowFieldErrorFactory(dispatch, 'url');

    return (
        <div className='has-feedback'>
            <InputGroup
                i18n={i18n}
                classNames={{
                    root: 'eh-input-url',
                    label: field.value ? 'eh-form-input-label-over' : undefined,
                }}
                label={field.value ? i18n.gettext('URL') : undefined}
                inputProps={{
                    autoComplete: 'url',
                    name: 'url',
                    placeholder: i18n.gettext('www.yourcompany.com'),
                    type: 'text',
                    value: field.value,
                    onChange,
                    onFocus: () => setShowFieldError(false),
                    onBlur: (e: React.FocusEvent<HTMLInputElement>) => {
                        onChange(e); // This is to show the error message when the user does focus out w/ having made any changes
                        setShowFieldError(true);
                    },
                }}
                validationState={
                    !field.valid && field.showError
                        ? InputGroup.VALIDATION_ERROR
                        : undefined
                }
                help={field.showError ? field.error : undefined}
            />
            <i className='form-control-feedback fa fa-cloud' />
        </div>
    );
};

export default Url;
